<template>
	<div class="get-started">
		<ProfilePic :user="invite.organization" class="org-logo" size="100px" />

		<div class="join-message">
			<i18n-t keypath="groupinvites_signup_join_org_label" tag="div">
				<template #GroupName>
					<strong>{{ invite.group.title }}</strong>
				</template>
				<template #OrgName>
					<strong>{{ invite.organization.name }}</strong>
				</template>
			</i18n-t>
		</div>

		<Button large block pronto class="get-started-button" :to="signup">
			{{ $t('groupinvites_signup_start_title') }}
		</Button>

		<Button pronto link :to="signin" replace>
			{{
				$t('groupinvites_org_member_already', {
					OrgName: invite.organization.name,
				})
			}}
		</Button>
	</div>
</template>

<script>
import { Button, ProfilePic } from '@/components/common'
import { joinFormRoute, signinRoute, getInvite } from './index'

export default {
	components: { Button, ProfilePic },
	data() {
		return {
			invite: null,
		}
	},

	created() {
		this.invite = getInvite()
	},

	computed: {
		signin() {
			return { name: signinRoute.name, params: this.$route.params }
		},
		signup() {
			return { name: joinFormRoute.name, params: this.$route.params }
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.get-started {
	@include flex-column-center;

	.org-logo {
		margin-top: 100px;
		margin-bottom: 13px;
	}

	.join-message {
		font-family: map-get($fonts, 400);
		font-size: 18px;
		text-align: center;
		color: var(--neutral-800);
		margin: 10px 85px 0;

		strong {
			font-family: map-get($fonts, 800);
		}
	}

	.get-started-button {
		margin-top: 90px;
		margin-bottom: 20px;
	}
}
</style>
